import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-course-viewer-footer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './footer.html',
})
export class CourseViewerFooter {
  @Input() progress = 60;
  @Input() remainingTime = '~15 min';
  @Input() sidebarCollapsed = false;
  @Input() currentLesson = 3;
  @Input() totalLessons = 5;
  @Input() moduleName = 'Módulo 2';
  @Input() canGoPrevious = true;
  @Input() canGoNext = true;
  @Output() previous = new EventEmitter<void>();
  @Output() next = new EventEmitter<void>();

  protected onPrevious(): void {
    this.previous.emit();
  }

  protected onNext(): void {
    this.next.emit();
  }
}
